import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import BackupData from "./pages/BackupData";
import PrivateRoute from "./Routes/PrivateRoute";
import BackupOutletMaster from "./components/BackupOutletMaster";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/backup-data"
          element={
            <PrivateRoute>
              <BackupData />
            </PrivateRoute>
          }
        />

         <Route
          path="/backup-data"
          element={
            <PrivateRoute>
              <BackupData />
            </PrivateRoute>
          }
        /> <Route
          path="/backup-outlet-master"
          element={
            <PrivateRoute>
              <BackupOutletMaster />
            </PrivateRoute>
          }
        />

        
      </Routes>
    </BrowserRouter>
  );
}

export default App;